// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"5f074658","498":"021699c0","598":"671e1dd6","703":"f682c59d"}[chunkId] + ".chunk.js";
};